import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { PlatformSelectOption } from 'ui-platform';

@Component({
  selector: 'sh-platform-select',
  templateUrl: './platform-select.component.html',
  styleUrl: './platform-select.component.scss',
  standalone: false
})
export class PlatformSelectComponent implements OnInit {
  options: PlatformSelectOption[] = [
    { value: 1, label: 'John Doe' },
    { value: 2, label: 'Markus Aurelius' },
    { value: 3, label: 'Kobayashi' }
  ];

  form = new FormGroup({
    selectOne: new FormControl(null, [Validators.required]),
    selectTwo: new FormControl(1),
    selectThree: new FormControl(null)
  });

  import = `
    import {UiPlatformSelectComponent} from 'ui-platform';
  `;

  usage = `
        <ui-platform-select
                formControlName="selectTwo"
                [label]="'Select person'"
                [placeholder]="'Pick name'"
                [options]="options"
        >
        </ui-platform-select>
    `;

  constructor() {}

  ngOnInit(): void {
    this.form.controls.selectOne.markAsTouched();
  }

  get selectOneError() {
    return this.form.controls['selectOne'].touched && this.form.controls['selectOne'].errors?.required;
  }
}
